import _cloneDeep from 'lodash/cloneDeep';

/**
 * ThingsService class.
 * Used to work with Things configs
 */
export default class ThingsService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @param {$filter} $filter - Angular $filter service
     * @constructor
     * @ngInject
     */
    constructor(RemoteConfigService, $filter) {
        this.RemoteConfigService = RemoteConfigService;
        this.$filter = $filter;

        this.config = _cloneDeep(this.RemoteConfigService.getThingsConfig());

        this.items = this.config.items || [];
        this.itemsMapByType = {};

        this.createThingsMapByType();
    }

    /**
     * Parse config items and create map for thing by thing.type
     * @returns {Object} Return object with things linked to thing.type inside that object
     */
    createThingsMapByType() {
        if (!this.items || !Array.isArray(this.items) || !this.items.length) return {};

        this.items.forEach((thing) => {
            thing.titlePlural = this.$filter('pluralFilter')(thing.description);

            this.itemsMapByType[thing.type] = thing;
        });

        this.sortThingsMap();

        return this.getThingsMapByType();
    }

    /**
     * Sort things map by thing.type
     * @returns {Object} Map of things
     */
    sortThingsMap() {
        this.itemsMapByType = Object.keys(this.itemsMapByType).sort().reduce((result, item) => {
            result[item] = this.itemsMapByType[item];

            return result;
        }, {});

        return this.itemsMapByType;
    }

    /**
     * Get thing by type
     * @param {string} type - Thing type
     * @returns {Object|null} Return Thing config object or Null on absent thing type
     */
    getThingByType(type) {
        return this.itemsMapByType[type] || null;
    }

    /**
     * Get all things (NOTICE: this is not a map of thing, this is original items from API/Server)
     * @returns {Array} Return array of thing configs
     */
    getAllThings() {
        return this.items;
    }

    /**
     * Get all things from map
     * @returns {Object} Return map of things by type
     */
    getThingsMapByType() {
        return this.itemsMapByType;
    }
}



// WEBPACK FOOTER //
// ./app/services/things/things.service.js